/** Ширина и отступы контента страниц (как на «Товары»). Остатки — отдельно, `max-w-full`. */
export const pageContentClassName = 'mx-auto w-full min-w-0 max-w-5xl p-4';
